// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible.js'
import echarts from 'echarts'
import axios from 'axios'
import Router from 'vue-router'
import NutUI from '@nutui/nutui';
// import moment from "vue-moment";

import Vant from 'vant'
import '@nutui/nutui/dist/nutui.css';
import './assets/iconfont/iconfont.css'
import 'vant/lib/index.css'
import { Toast } from 'vant'
NutUI.install(Vue);
// Vue.use(moment); //实例
Vue.use(Vant);
Vue.prototype.$toast = Toast;

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.prototype.$http = axios

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
//     if (sessionStorage.getItem('xggadminsid')) { // 查询本地存储信息是否已经登陆
//       next()
//     } else {
//       next({
//         path: '/login', // 未登录则跳转至login页面
//         query: {redirect: to.fullPath} // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
//       })
//     }
//   } else {
//     next()
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js